module.exports = __webpack_public_path__ + "static/media/download-figma.47de9bf8.svg";